import { Component, type ReactNode } from "react";
import { t } from "../i18n/en";

/**
 * A UI bug shows a recovery screen instead of a blank page.
 *
 * Without this, any render-time exception unmounts the whole tree and a home-screen PWA shows
 * nothing at all — no error, no way out but force-quitting. Reloading is the right recovery here:
 * the app holds no unsaved state worth preserving, and a fresh load picks up a fixed deploy.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[flight-radar] render error", error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="screen centered">
        <div className="card">
          <div className="brand">
            <h1>{t.errors.title}</h1>
            <p>{t.errors.body}</p>
          </div>
          <p className="hint mono">{this.state.error.message}</p>
          <button onClick={() => window.location.reload()}>{t.errors.reload}</button>
        </div>
      </div>
    );
  }
}
